import { useNavigate } from "react-router";
import { ArrowLeftIcon, Home02Icon } from "vega-icons";
import { Four04Illustration } from "vega-illustrations";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { useTheme } from "@vega-core/context/ThemeContext/ThemeContext";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { CommonPaths } from "../../paths";

export function PageNotFound() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const {
    theme: { logos },
  } = usePublicConfig();

  return (
    <div
      className={cnTwMerge(
        "flex flex-col justify-center   p-4 lg:relative lg:p-0 bg:background/secondary overflow-hidden touch-none",
        theme,
      )}
    >
      <div className="flex-shrink-0 hidden md:flex lg:pt-4 lg:pl-4">
        <img
          alt="vega"
          className="w-auto h-10 md:h-auto"
          src={theme === "dark" ? logos.smallLogoDark : logos.smallLogoLight}
        />
      </div>
      <div className="flex-shrink-0  py-32 my-auto text-center ">
        <Four04Illustration className="w-full mx-auto" />
        <h1 className="heading-4 mt-8">{m.titles_pageNotFound()}</h1>
        <div className="md:mx-auto md:max-w-xl">
          <div className="body-semi-large-regular text-text/secondary pt-2 mx-w-xs">
            {m.titles_pageNotFoundDescription()}
          </div>
        </div>

        <div className="flex flex-col-reverse sm:flex-row items-center justify-center sm:max-w-xs sm:mx-auto gap-4 sm:gap-8 mt-8">
          <ThemedButton
            className="w-full md:w-auto"
            dataTestId="back-button"
            icon={<ArrowLeftIcon />}
            onClick={() => navigate(CommonPaths.Home)}
            variant="secondary"
          >
            {m.btn_goBack()}
          </ThemedButton>
          <ThemedButton
            className="w-full md:w-auto"
            dataTestId="home-button"
            icon={<Home02Icon />}
            onClick={() => navigate(CommonPaths.Home)}
          >
            {m.home_subscriptionModal_primaryActionTitle()}
          </ThemedButton>
        </div>
      </div>
    </div>
  );
}
